<template>
    <div class="baggage-content">
        <label class="baggage-title" v-if="showTitle && showIncludedPerItem">
            <Translation :translate="{ key: 'shared.is_included_in_ticket' }" />
        </label>

        <div v-if="!split" class="baggage-content-inner">
            <div>
                <label v-if="showLabels && !isOneWay" class="baggage-sub-title">
                    <Translation :translate="{ key: 'shared.outbound_homebound' }" />
                </label>
                <List
                    :items="items"
                    :leg="LegType.RoundTrip"
                    :type="type"
                    :showIncludedPerItem="showIncludedPerItem"
                    :noBaggageSelectionCabinBagLabel="noBaggageSelectionCabinBagLabel"
                    :noBaggageSelectionCheckedBagLabel="noBaggageSelectionCheckedBagLabel"
                    :noBaggageSelectionLabel="noBaggageSelectionLabel" />
            </div>
            <div v-if="isTablet && showLabels && !isOneWay" />
        </div>

        <div v-else class="baggage-content-inner">
            <div>
                <label v-if="showLabels" class="baggage-sub-title">
                    <Translation :translate="{ key: 'shared.outbound_flight' }" />
                </label>
                <List
                    :items="outboundItems"
                    :leg="LegType.Outbound"
                    :type="type"
                    :showIncludedPerItem="showIncludedPerItem"
                    :noBaggageSelectionCabinBagLabel="noBaggageSelectionCabinBagLabel"
                    :noBaggageSelectionCheckedBagLabel="noBaggageSelectionCheckedBagLabel"
                    :noBaggageSelectionLabel="noBaggageSelectionLabel" />
            </div>

            <div>
                <label v-if="showLabels" class="baggage-sub-title">
                    <Translation :translate="{ key: 'shared.homebound' }" />
                </label>
                <List
                    :items="inboundItems"
                    :leg="LegType.Inbound"
                    :type="type"
                    :showIncludedPerItem="showIncludedPerItem"
                    :noBaggageSelectionCabinBagLabel="noBaggageSelectionCabinBagLabel"
                    :noBaggageSelectionCheckedBagLabel="noBaggageSelectionCheckedBagLabel"
                    :noBaggageSelectionLabel="noBaggageSelectionLabel" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { PropType, defineComponent, computed } from 'vue';
    import { BaggageIncluded, BaggageType, LegType } from '@shared/interfaces/baggage';
    import { useScreenSize } from '@shared/helpers/viewport';
    import Translation from '@ui/components/Translation/Translation.vue';
    import List from './List.vue';

    export default defineComponent({
        name: 'Included',
        components: { List, Translation },
        props: {
            items: {
                type: Array as PropType<BaggageIncluded[]>,
                default: () => [],
            },
            type: { type: String as PropType<BaggageType>, required: true },
            split: { type: Boolean, default: false },
            showTitle: { type: Boolean, default: false },
            showLabels: { type: Boolean, default: false },
            showIncludedPerItem: { type: Boolean, default: false },
            isOneWay: { type: Boolean, default: false },
            noBaggageSelectionCabinBagLabel: { type: String, required: true },
            noBaggageSelectionCheckedBagLabel: { type: String, required: true },
            noBaggageSelectionLabel: { type: String, required: true },
        },
        setup(props) {
            const { isTablet } = useScreenSize();

            const outboundItems = computed((): BaggageIncluded[] =>
                getBaggagesIncludedBySector(props.items, 1)
            );

            const inboundItems = computed((): BaggageIncluded[] =>
                getBaggagesIncludedBySector(props.items, 2)
            );

            const getBaggagesIncludedBySector = (
                baggages: BaggageIncluded[],
                sector: number
            ) =>
                [...baggages].filter((x: BaggageIncluded) =>
                    x.PerSector?.find((x) => x.SectorNumber === sector)
                );

            return { isTablet, LegType, outboundItems, inboundItems };
        },
    });
</script>
